import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { FieldWrap } from './index';
import { FormError } from '../../interfaces';

const useStyles = createUseStyles({
    input: {
        backgroundColor: 'white',
        transition: 'background-color .1s ease-in',
        '&[disabled]': {
            backgroundColor: '#dddddd',
            cursor: 'not-allowed',
        },
    },
});

interface InputProps {
    name: string;
    label: string;
    type?: string;
    error?: FormError;
    required?: boolean;
    register: (options: object) => any;
    validation?: object;
    disabled?: boolean;
    checked?: boolean;
    defaultValue?: string | number;
    min?: number;
    max?: number;
    readOnly?: boolean;
    multiple?: boolean;
}

const Input: React.FC<InputProps> = ({
    name,
    label,
    error,
    type = 'text',
    register,
    required = false,
    validation,
    disabled = false,
    checked,
    defaultValue,
    min,
    max,
    readOnly = false,
    multiple = false,
}: InputProps) => {
    const classes = useStyles();

    return (
        <FieldWrap label={label} error={error} required={required}>
            <input
                name={name}
                className={classes.input}
                type={type}
                disabled={disabled}
                required={required}
                checked={checked}
                readOnly={readOnly}
                defaultValue={defaultValue}
                ref={register({ required, ...validation })}
                min={min}
                max={max}
                multiple={multiple}
            />
        </FieldWrap>
    );
};

export default React.memo(Input);
